import React from 'react';
import Modal from '../Modal2';
import _ from 'lodash';
import { FlexRemoteRenameArgs, FlexRemoteRenameQuery, RepoItem } from '../../autogenerated/ZoomBridge';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import ErrorHandler from '../../error/ErrorHandler';
import AssetListCache from '../../queries/asset/AssetListCache';
import t from '../../i18n/I18n';
import './RenameModal.css';
import StringUtil from '../../util/StringUtil';
import { forceUpdateStatus } from '../../util/AssetsUtil';
import FileInfoUtil from '../../util/FileInfoUtil';

type Props = {
  asset: RepoItem,
  onClose: Function,
  fetchAssets: Function
};

export default class RenameModal extends React.Component<Props> {
  _assetListCache: AssetListCache;

  constructor(props) {
    super(props);
    this._assetListCache = AssetListCache.getInstance();
    this.state = {
      error: ''
    };
  }

  static defaultProps = {
    fetchAssets: _.noop
  };

  componentDidMount() {
    this.showSelectionOnText();
  }
  
  render() {
    const { asset, onClose } = this.props;
    const isFolder = FileInfoUtil.isFolder(asset);
    const modalTitle = isFolder ?  t('RENAME_FOLDER_TITLE') :t('RENAME_ASSET_TITLE');
    const modalProps = {
      name: 'RenameModal',
      title: modalTitle,
      onClose,
      buttons: [
        { label: t('CANCEL'), type: 'CANCEL', onClick: onClose },
        { label: t('RENAME'), type: 'PRIMARY', onClick: () => this.rename(this.refs.newName.value) }
      ]
    };

    return (
      <Modal {...modalProps} closeOnEsc={true} closeOnOutsideClick={true}>
        <div>
          <div style={styles.asset}>
            <img
              style={{ width: '32px', height: '32px', objectFit: asset && asset.getFrn() === 0 ? 'contain' : 'cover' }}
              src={ThumbnailUtil.toThumbUrl(asset)}
            />
            <span
              style={{ margin: 'auto .7em', color: 'var(--primary-font-color)', fontSize: '14px', overflowX: 'auto' }}>
              {asset.getName()}
            </span>
            {/* <span style={{ margin: 'auto 1em auto auto', backgroundColor: '#3B99FC', color: 'white', width: '16px', height: '16px', fontSize: '11px', textAlign: 'center' }}>&#x2714;</span> */}
          </div>
          <input
            ref="newName"
            type="text"
            defaultValue={asset.getName()}
            autoFocus={true}
            onKeyDown={(event) => (
              event.stopPropagation(), event.which === 13 ? this.onEnterKey(this.refs.newName.value) : null
            )}
            style={{
              width: '100%',
              padding: '.5em',
              border: 'none',
              borderRadius: '2px',
              boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
              fontSize: '16px',
              color: 'var(--primary-font-color)',
              backgroundColor: 'var(--primary-header-bg)'
            }}
          />
          <div className='error'>{this.state.error}</div>
        </div>
      </Modal>
    );
  }

  onEnterKey(newName) {
    this.rename(newName);
  }

  showSelectionOnText() {
    const renameInput = this.refs.newName;
    renameInput.setSelectionRange(0, renameInput.value.lastIndexOf('.'));
  }

   showErrorMessage = () => {
    const {asset} = this.props;
    const isFolder  = FileInfoUtil.isFolder(asset);
   this.setState({error : isFolder ? t('PLEASE_ENTER_THE_FOLDER_NAME') : t ('PLEASE_ENTER_THE_ASSET_NAME')});
   };

  async rename(newName) {
    if (StringUtil.isEmpty(newName)){
      return this.showErrorMessage();
    };
    if (this.props.asset.getName() === newName.trim()) {
      this.props.onClose();
      return;
    }
    const { asset, onClose } = this.props;
    window.gs.setProgress(true);
    const renameQuery = new FlexRemoteRenameQuery();
    const renameMessage = new FlexRemoteRenameArgs();
    const remotePath = ThumbnailUtil.computeRemotePathOfAssets([asset])[0];
    if (remotePath.charAt(0) === '/') {
      remotePath.substr(1);
    }
    renameMessage.setBranch('head');
    renameMessage.setLogMsg('Renaming file ');
    renameMessage.setRemotePath(remotePath);
    renameMessage.setNewName(newName);

    renameQuery.message = renameMessage;
    renameQuery.run(false, true).then(
      // eslint-disable-next-line no-unused-vars
      (resp) => {
        window.gs.setProgress(false);
        asset.setName(newName);
        let remotePath = asset.getRemotePath();
        if (remotePath) {
          let parts = remotePath.split('/');
          parts.pop();
          parts.push(newName);
          asset.setRemotePath(parts.join('/'));
        }
        // let isWCFile = false;
        // if (asset.wcStatusObject && StringUtil.isNotEmpty(asset.wcStatusObject._localPath)) {
        //   isWCFile = true;
        // }
        this.props.fetchAssets();
        onClose();
        window.render();
      },
      (error) => {
        window.gs.setProgress(false);
        ErrorHandler.handleError(error);
        this.props.onClose();
      }
    );
  }
}
const styles = {
  asset: {
    width: '100%',
    background: 'var(--primary-header-bg)',
    color: 'var(--primary-font-color)',
    padding: '5px',
    display: 'flex',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
    cursor: 'pointer',
    fontSize: '14px',
    marginBottom: '15px'
  }
};
